<template>
  <div>
    <div class="row">
      <div class="col-12">
        <strong>{{ $t('newAction.stepOne.widget.type') }}:</strong>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12 widget-types">
        <div
          id="modal-type"
          class="widget-type"
          @click="action.widget.displayType = 'modal'"
        >
          <img src="../../../../assets/widget-modal.png" alt="Modal type" />
        </div>
        <div
          id="bar-type"
          class="widget-type"
          @click="action.widget.displayType = 'bar'"
        >
          <img src="../../../../assets/widget-bar.png" alt="Bar type" />
        </div>
        <div
          id="box-type"
          class="widget-type"
          @click="action.widget.displayType = 'box'"
        >
          <img src="../../../../assets/widget-box.png" alt="Box type" />
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12">
        <div class="form-group">
          <label class="idx-bold" for="widget-domain">
            {{ $t('newAction.stepOne.widget.allowedDomain') }}:
          </label>
          <input
            type="text"
            id="widget-domain"
            class="form-control"
            placeholder="Ex.: https://www.indecx.com.br"
            v-model="action.widget.allowedDomain"
          />
        </div>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-12">
        <p>
          <strong>{{ $t('newAction.stepOne.widget.scriptLabel') }}:</strong>
        </p>
        <div class="enable-area">
          <div class="custom-switch">
            <input
              type="checkbox"
              class="custom-control-input"
              id="switch-widget-name"
              v-model="action.widget.enableName"
            />
            <label class="custom-control-label" for="switch-widget-name">
              {{ $t('newAction.stepOne.widget.name') }}
            </label>
          </div>
          <div class="custom-switch ml-3">
            <input
              type="checkbox"
              class="custom-control-input"
              id="switch-widget-email"
              v-model="action.widget.enableEmail"
              @click="handleEmail($event)"
            />
            <label class="custom-control-label" for="switch-widget-email">
              E-mail
            </label>
          </div>
          <div class="custom-switch ml-3">
            <input
              type="checkbox"
              class="custom-control-input"
              id="switch-widget-phone"
              v-model="action.widget.enablePhone"
              @click="handlePhone($event)"
            />
            <label class="custom-control-label" for="switch-widget-phone">
              {{ $t('newAction.stepOne.widget.phone') }}
            </label>
          </div>
          <div class="custom-switch ml-3">
            <input
              type="checkbox"
              class="custom-control-input"
              id="switch-widget-indicators"
              v-model="action.widget.enableIndicators"
            />
            <label class="custom-control-label" for="switch-widget-indicators">
              {{ $t('newAction.stepOne.widget.indicators') }}
            </label>
          </div>
          <div class="custom-switch" style="margin-left: auto;">
            <input
              type="checkbox"
              class="custom-control-input"
              id="switch-widget-disabled"
              v-model="action.widget.disabled"
            />
            <label
              :class="{ 'text-danger': action.widget.disabled }"
              class="custom-control-label"
              for="switch-widget-disabled"
            >
              {{
                action.widget.disabled
                  ? $t('newAction.stepOne.widget.paused')
                  : $t('newAction.stepOne.widget.disabled')
              }}
            </label>
          </div>
        </div>

        <div class="script-area mt-3">
          <code class="code-area">
            <span>{{ script.start }}</span>
            <span>{{ script.line1 }}</span>
            <span>{{ script.line2 }}</span>
            <span>&nbsp;&nbsp;{{ companyIdLine }}</span>
            <span>&nbsp;&nbsp;{{ actionIdLine }}</span>

            <span v-if="action.widget.enableName">
              &nbsp;&nbsp;{{ script.line5 }}
            </span>

            <span v-if="action.widget.enableEmail"
              >&nbsp;&nbsp;{{ script.line6 }}
            </span>

            <span v-if="action.widget.enablePhone">
              &nbsp;&nbsp;{{ script.line7 }}
            </span>

            <span v-if="action.widget.enableIndicators">
              &nbsp;&nbsp;{{ script.line8 }}
            </span>

            <span class="script">
              {{ script.line9 }}
            </span>
            <span>{{ script.end }}</span>
          </code>

          <div class="mt-3">
            <button
              class="btn btn-primary mr-2"
              @click="copyScript"
              title="Copiar script"
            >
              {{ $t('newAction.stepOne.widget.copy') }}
            </button>

            <button
              v-if="!loadingPreview"
              class="btn btn-primary"
              @click="preview"
              title="Simular widget"
            >
              {{ $t('newAction.stepOne.widget.simulate') }}
            </button>
            <span v-else class="mt-1">
              <b-spinner
                variant="success"
                type="grow"
                label="Spinning"
                class="bg-primary"
              ></b-spinner>
            </span>
          </div>
        </div>

        <span class="comment-warn">
          {{ $t('newAction.stepOne.widget.comment') }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import swal from 'sweetalert';

export default {
  data: () => ({
    userAuth: null,
    loadingPreview: false,
    script: {
      start: '<script>',
      line1: `(function(){`,
      line2: `var c = {`,
      line5: `  name: "João Cléber",`,
      line6: `  email: "joao@cleber.com",`,
      line7: `  phone: "5519999999999",`,
      line8: `  indicators: { test: "test" }`,
      line9: `}; var e; if (document.getElementById("script-indecx")) { return } e = document.createElement("script"); e.id = "script-indecx"; e.src = "script-url"; e.type = "text/javascript"; e.async = true; e.onload = e.onreadystatechange = function() { var h = this.readyState; if (h && h != "complete" && h != "loaded") { return } try { IndeCX(c); } catch (i) {} }; document.body.appendChild(e); }())`,
      end: `<${'/'}script>`,
    },
  }),

  computed: {
    ...mapState('actions', ['action', 'closingMessage']),

    companyIdLine() {
      return `  key: "${this.userAuth.companyId}",`;
    },

    actionIdLine() {
      return `  action: "${this.action._id}",`;
    },

    scriptUrl() {
      let scriptUrl = 'https://indecx-widget.s3.amazonaws.com/widget.js';

      if (window.location.hostname === 'localhost') {
        scriptUrl = 'https://indecx-widget.s3.amazonaws.com/widget-dev.js';
      } else if (window.location.hostname === 'indecx.pe') {
        scriptUrl = 'https://indecx-widget.s3.amazonaws.com/widget-staging.js';
      } else if (window.location.hostname === 'stg.idcx-verse.com') {
        scriptUrl = 'https://indecx-widget.s3.amazonaws.com/widget-staging.js';
      }

      return scriptUrl;
    },

    formattedScript() {
      return (
        `${this.script.start} \n` +
        `${this.script.line1} \n` +
        `${this.script.line2} \n` +
        `${this.companyIdLine} \n` +
        `${this.actionIdLine} \n` +
        `${this.action.widget.enableName ? `${this.script.line5}\n` : ''}` +
        `${this.action.widget.enableEmail ? `${this.script.line6}\n` : ''}` +
        `${this.action.widget.enablePhone ? `${this.script.line7}\n` : ''}` +
        `${
          this.action.widget.enableIndicators ? `${this.script.line8}\n` : ''
        }` +
        `${this.script.line9} \n` +
        `${this.script.end} \n`
      );
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    this.script.line9 = this.script.line9.replace('script-url', this.scriptUrl);
  },

  mounted() {
    const element = document.getElementById(
      `${this.action.widget.displayType}-type`,
    );

    element.classList.add('widget-active');
  },

  watch: {
    'action.widget.displayType': function watchWidgetType(newValue, oldValue) {
      const elementEnabled = document.getElementById(`${newValue}-type`);
      elementEnabled.classList.add('widget-active');

      const elementDisabled = document.getElementById(`${oldValue}-type`);
      elementDisabled.classList.remove('widget-active');
    },
  },

  methods: {
    handleEmail(event) {
      if (!event.target.checked && !this.action.widget.enablePhone) {
        this.action.widget.enableEmail = true;
        event.target.checked = true;

        swal(
          'Oops...',
          'O script deve conter os campos email ou senha para a identificação do cliente.',
          'error',
        );
      }
    },

    handlePhone(event) {
      if (!event.target.checked && !this.action.widget.enableEmail) {
        this.action.widget.enablePhone = true;
        event.target.checked = true;

        swal(
          'Oops...',
          'O script deve conter os campos email ou senha para a identificação do cliente.',
          'error',
        );
      }
    },

    copyScript() {
      const textArea = document.createElement('textarea');

      document.body.appendChild(textArea);
      textArea.value = this.formattedScript;
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);

      this.$bvToast.toast(
        this.$t('newAction.stepOne.widget.copiedDescription'),
        {
          title: this.$t('newAction.stepOne.widget.copiedTitle'),
          autoHideDelay: 3000,
          variant: 'success',
          solid: true,
        },
      );
    },

    preview() {
      this.loadingPreview = true;

      setTimeout(() => {
        this.loadingPreview = false;
      }, 3000);

      const tagScript = document.getElementById('script-indecx');
      const div = document.getElementById('indecx-widget');

      if (tagScript) {
        tagScript.parentElement.removeChild(tagScript);
      }

      if (div) {
        div.parentElement.removeChild(div);
      }

      localStorage.setItem(
        '@IndeCX:action-widget',
        JSON.stringify({
          ...this.action,
          closingMessage: this.closingMessage,
        }),
      );

      const c = {
        key: this.userAuth.companyId,
        action: this.action._id,
        name: this.userAuth.name,
        preview: true,
        widgetType: this.action.widget.displayType,
      };

      const e = document.createElement('script');
      e.id = 'script-indecx';
      e.src = this.scriptUrl;
      e.type = 'text/javascript';
      e.async = true;

      // eslint-disable-next-line
      e.onload = e.onreadystatechange = function () {
        const h = this.readyState;
        // eslint-disable-next-line
        if (h && h != 'complete' && h != 'loaded') {
          return;
        }
        try {
          // eslint-disable-next-line
          IndeCX(c);
        } catch (i) {
          window.console.log(i);
        }
      };

      document.body.appendChild(e);
    },
  },
};
</script>

<style lang="scss" scoped>
.widget-types {
  display: flex;
  justify-content: space-between;

  .widget-type {
    display: flex;
    flex-direction: column;
    width: 227px;
    padding: 20px;
    border: 1px solid #c1c1c1;
    border-radius: 5px;
    overflow: hidden;
    cursor: pointer;

    &:hover {
      border: 3px solid #21bb6b;
    }

    img {
      max-height: 100%;
    }
  }
}

.widget-active {
  border: 3px solid #21bb6b !important;
}

.script-area {
  font-size: 14px;
  width: 100%;
  background-color: #eeecec;
  padding: 16px;
  border-radius: 5px;
  overflow-x: auto;

  code {
    color: #000;
  }

  .code-area {
    display: flex;
    flex-direction: column;
  }

  .script {
    white-space: nowrap;
  }
}

.enable-area {
  display: flex;
  flex-direction: row;
}

.comment-warn {
  color: #9b9898;
  font-size: 14px;
  font-style: italic;
}

@media only screen and (max-width: 1625px) {
  .widget-types {
    .widget-type {
      height: 180px;
      width: 187px;
    }
  }
}

@media only screen and (max-width: 1400px) {
  .widget-types {
    .widget-type {
      height: 150px;
      width: 157px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/action-templates/widget/index.vue